import data from './../resources/data'
import methods from './methods'
import props from './props'
import validations from './validations'
import mounted from './mounted'
import computed from './computed'

export default {
  data,
  methods,
  props,
  validations,
  mounted,
  computed
}



// WEBPACK FOOTER //
// ./src/app/professional/company/staffs/form/components/invite/resources/index.js